module.exports = __webpack_public_path__ + "static/media/ot-loader.258a2027.svg";